module.exports = __webpack_public_path__ + "img/equilibrium-540w.944ef46f.jpg";